import { api } from "@/lib/http";

export type GatewayKeyEntity = {
  id: number;
  name: string;
  policy_mode: string;
};

export type GatewayKeyItem = {
  id: string;
  name: string;
  description: string | null;
  status: "active" | "revoked";
  revoked_at: string | null;
  last_used_at: string | null;
  created_at: string;
  updated_at: string;
  providers: Record<string, string[]>;
  entities: Array<GatewayKeyEntity>;
};

export type GatewayKeysListResponse = {
  count: number;
  items: Array<GatewayKeyItem>;
  next_page: number | null;
  previous_page: number | null;
};

function listActive(page: number, perPage = 10) {
  return api.raw
    .get("api/v1/my-gateway_keys/", {
      searchParams: { page, per_page: perPage, status: "active" },
    })
    .json<GatewayKeysListResponse>();
}

function listRevoked(page: number, perPage = 10) {
  return api.raw
    .get("api/v1/my-gateway_keys/", {
      searchParams: { page, per_page: perPage, status: "revoked" },
    })
    .json<GatewayKeysListResponse>();
}

function revoke(id: string) {
  return api.raw.post(`api/v1/my-gateway_keys/${id}/revoke`);
}

function rename(id: string, name: string) {
  return api.raw
    .patch(`api/v1/my-gateway_keys/${id}`, { json: { name } })
    .json<GatewayKeyItem>();
}

export default {
  listActive,
  listRevoked,
  revoke,
  rename,
};
